module.exports = __webpack_public_path__ + "static/media/logo10.526b6747.png";